<template>
  <div>
    <Breadcrumb />
    <el-card class="box-card mt-20">
      <div slot="header" class="clearfix">
        <span>{{
          brandInfo.id === "" || brandInfo.id === undefined
            ? "新增品牌品类信息"
            : "品牌品类信息维护"
        }}</span>
      </div>
      <el-form
        ref="brandForm"
        :model="brandInfo"
        :rules="rules"
        class="add-form"
        :label-position="labelPosition"
        label-width="140px"
      >
        <div class="add-form-item">
          <el-form-item label=" 国家名称：" v-if="brandInfo.id">
            <span>{{ brandInfo.countryName }}</span>
          </el-form-item>
          <el-form-item
            label=" 国家名称："
            prop="baseDataCountryOidCode"
            v-else
          >
            <el-select
              v-model="brandInfo.baseDataCountryOidCode"
              placeholder="请选择"
              filterable
              style="width: 100%"
            >
              <el-option
                v-for="item in countryInfo"
                :key="item.baseDataCountryOidCode"
                :label="item.baseDataCountryName"
                :value="item.baseDataCountryOidCode"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="add-form-item">
          <el-form-item label=" 数据类型：" v-if="brandInfo.id">
            <span>{{ brandInfo.baseDataType === 1 ? "品牌" : "品类" }}</span>
          </el-form-item>

          <el-form-item label=" 数据类型：" prop="baseDataType" v-else>
            <el-select
              v-model="brandInfo.baseDataType"
              placeholder="请选择"
              style="width: 100%"
              @change="changeDataType"
            >
              <el-option
                v-for="item in baseDataList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="add-form-item">
          <el-form-item
            label=" 品牌或品类名称："
            prop="brandClassName"
            v-if="brandInfo.id"
          >
            <el-input v-model="brandInfo.brandClassName"></el-input>
          </el-form-item>

          <el-form-item label=" 品牌或品类名称：" prop="brandClassName" v-else>
            <el-input v-model="brandInfo.brandClassName"></el-input>
          </el-form-item>
          <span class="validate ml-20"> * 最多输入80个字符</span>
        </div>
        <div class="add-form-item">
          <el-form-item label=" 品牌或品类OID编码：" v-if="brandInfo.id">
            <span>{{ brandInfo.brandClassOidCode }}</span>
          </el-form-item>
          <el-form-item
            label=" 品牌或品类OID编码："
            prop="brandClassOidCode"
            v-else
          >
            <el-select
              v-model="brandInfo.brandClassOidCode"
              placeholder="请选择"
              filterable
              style="width: 100%"
            >
              <el-option
                v-for="item in brandClassInfo"
                :key="item.brandCode"
                :label="item.brandName"
                :value="item.brandCode"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <br />
        <el-form-item>
          <el-button type="primary" @click="submit">确定</el-button>
          <el-button @click="goBack">返回</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb";
import product from "../../../store/modules/product";

export default {
  components: {
    Breadcrumb
  },
  data() {
    return {
      labelPosition: "left",
      baseDataList: [
        {
          value: 1,
          label: "品牌"
        },
        {
          value: 2,
          label: "品类"
        }
      ],
      brandClassInfo: [],
      countryInfo: [],
      brandInfo: {
        id: "",
        countryName: "",
        baseDataCountryOidCode: "",
        baseDataType: 1,
        brandClassName: "",
        brandClassOidCode: ""
      },
      rules: {
        baseDataCountryOidCode: [
          { required: true, message: "请选择国家信息", trigger: "change" }
        ],
        baseDataType: [
          { required: true, message: "请选择数据类型", trigger: "change" }
        ],
        brandClassName: [
          {
            required: true,
            message: "请输入品类名称",
            trigger: "blur"
          },
          {
            max: 80,
            message: "最多输入80个字符",
            trigger: "change"
          }
        ],
        brandClassOidCode: [
          { required: true, message: "请选择品类OID编码", trigger: "change" }
        ]
      }
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    //数据类型改变时修改品牌码下拉数据
    changeDataType(val) {
      let _this = this;
      if (val === 1) {
        _this.getBrandSelectInfo();
      } else {
        _this.getBrandClassSelectInfo();
      }
    },
    //获取国家信息
    getCountryInfo() {
      let _this = this;
      if (
        _this.brandInfo.id === null ||
        _this.brandInfo.id === "" ||
        _this.brandInfo.id === undefined
      ) {
        let param = {
          url: "/api/country/getCountryInfo"
        };

        _this.$store.dispatch("getCountryInfo", param).then(() => {
          _this.countryInfo = _this.$store.state.country.allCountryInfo;
        });
      }
    },
    //获取品牌下拉数据
    getBrandSelectInfo() {
      let _this = this;
      if (
        _this.brandInfo.id === null ||
        _this.brandInfo.id === "" ||
        _this.brandInfo.id === undefined
      ) {
        let param = {
          url: "/api/brand/getAllBrandInfo"
        };

        _this.$store.dispatch("getAllBrandInfo", param).then(() => {
          _this.brandClassInfo = _this.$store.state.brand.allBrandInfo;
        });
      }
    },
    //获取全部品类下拉数据
    getBrandClassSelectInfo() {
      let _this = this;
      let param = {
        url: "/api/productCode/getBrandClassInfo"
      };

      _this.$store.dispatch("getBrandClassInfo", param).then(() => {
        _this.brandInfo.brandClassOidCode = "";
        _this.brandClassInfo = _this.$store.state.product.brandClassInfo;
      });
    },
    //处理更新数据
    handleUpdateData() {
      let _this = this;
      if (
        _this.brandInfo.id !== null &&
        _this.brandInfo.id !== "" &&
        _this.brandInfo.id !== undefined
      ) {
        let brandInfo = _this.$store.state.country.editBrandInfo;
        _this.brandInfo.countryName = brandInfo.countryName;
        _this.brandInfo.baseDataType = brandInfo.baseDataType;
        _this.brandInfo.brandClassName = brandInfo.brandClassName;
        _this.brandInfo.brandClassOidCode = brandInfo.brandClassOidCode;
      }
    },
    submit() {
      let _this = this;
      let param = {
        url: "/api/countryBrand/saveBrandClassInfo"
      };
      if (
        _this.brandInfo.id === null ||
        _this.brandInfo.id === "" ||
        _this.brandInfo.id === undefined
      ) {
        this.$refs["brandForm"].validate(valid => {
          if (valid) {
            param.params = {
              baseDataCountryOidCode: _this.brandInfo.baseDataCountryOidCode,
              baseDataType: _this.brandInfo.baseDataType,
              brandClassName: _this.brandInfo.brandClassName,
              brandClassOidCode: _this.brandInfo.brandClassOidCode
            };

            _this.$Api
              .post(param.url, param.params)
              .then(response => {
                if (response.status === 200) {
                  _this.$message({
                    message: response.msg,
                    type: "success"
                  });
                  _this.$router.push({
                    name: "brandCategory"
                  });
                } else {
                  _this.$message({
                    message: "系统异常!",
                    type: "error"
                  });
                }
              })
              .catch(err => {});
          }
        });
      } else {
        param.params = {
          id: _this.brandInfo.id,
          brandClassName: _this.brandInfo.brandClassName
        };

        _this.$Api
          .post(param.url, param.params)
          .then(response => {
            if (response.status === 200) {
              _this.$message({
                message: response.msg,
                type: "success"
              });
              _this.$router.push({
                name: "brandCategory"
              });
            } else {
              _this.$message({
                message: "系统异常!",
                type: "error"
              });
            }
          })
          .catch(err => {});
      }
    }
  },
  created() {
    let _this = this;
    _this.brandInfo.id = this.$route.query.id;
    //处理更新数据
    _this.handleUpdateData();
    //获取国家下拉数据
    _this.getCountryInfo();
    //获取品牌下拉数据
    _this.getBrandSelectInfo();
  }
};
</script>

<style lang="sass" scoped>
.add-form-item
    width: 700px
    display: flex

    .el-form-item
        width: 460px

    .validate
        height: 40px
        line-height: 40px
        font-size: 14px
        color: #E6A23C
</style>
